import gql from 'graphql-tag'

export const GET_VGROUPS_PAGINATED = gql`
  query VgroupsPaginated($filter: GetVgroupsFilterWithPagination) {
    vgroupsPaginated(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      vgroups {
        ids
        data {
          id
          name
          totalVehicle
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`
